export default [
    //Ground blocks start here:
    {
        size: {
            height: 30,
            width: 60
        }, 
        position: {
            x: 160,
            y: 0
        }
    },
    {
        size: {
            height: 60,
            width: 30
        }, 
        position: {
            x: 240,
            y: 0
        }
    },
    {
        size: {
            height: 30,
            width: 60
        }, 
        position: {
            x: 380,
            y: 0
        }
    },
    {
        size: {
            height: 80,
            width: 30
        }, 
        position: {
            x: 560,
            y: 0
        }
    }
]


/** WEBPACK FOOTER **
 ** ./src/data/level5.js
 **/